import {
  GetUserPreferencesV2Command,
  GetUserPreferencesV2CommandInput,
  LinkSlackIdentityCommand,
  LinkSlackIdentityCommandInput,
  UpdateUserPreferencesV2Command,
  UpdateUserPreferencesV2CommandInput,
} from '@amzn/gbsa-orbit-typescript-client';
import { apiOrbitClient } from 'src/data/api/apiOrbitClient';

export const userPreferencesService = {
  get: (data: GetUserPreferencesV2CommandInput) => {
    return apiOrbitClient.send(new GetUserPreferencesV2Command(data));
  },

  update: (data: UpdateUserPreferencesV2CommandInput) => {
    return apiOrbitClient.send(new UpdateUserPreferencesV2Command(data));
  },

  /**
   * Resolves the user's Amazon alias to their Slack user ID (server-side via
   * SLAB) and stores it on their preferences. Idempotent — re-linking
   * refreshes the stored identity. The operation takes no request body.
   */
  linkSlackIdentity: (data: LinkSlackIdentityCommandInput) => {
    return apiOrbitClient.send(new LinkSlackIdentityCommand(data));
  },
};
